const api_base_url = "/wp-json/rs/v1/";

/**
 * Kontaktuje /api_base_url/{requestEndPointURL} pro POST a zisku odpovědi
 * 
 * @param {String} requestEndPointURL - Hodnota textového řetězce, která určuje konkrétní endpoint, který se má konktaktovat  
 * @param {Object} requestBody - Objekt, který je potřeba předat API bráně jako tělo požadavku 
 * 
 * @throws {Error} vrátí chybu, když se nepovede získat odpověď
 * 
 * @returns {String} Hodnota textového řetězce obsahující očekávanou odpověď API
 */
export async function APIrequestPOST(requestEndPointURL, requestBody)
{
    const response = await fetch
    (
        api_base_url + requestEndPointURL,
        {
            method: 'POST',
            headers : 
            {
                'Content-Type' : 'application/json',
            },
            body : JSON.stringify(requestBody)
        }
    );

    if(!response.ok) 
    {
        const errorText = await response.text();
        console.error(`APIrequestPOST Error: ${response.status} - ${errorText}`);

        throw new Error(`APIrequestPOST Error: ${response.status} - ${errorText}`);
    }
    else 
        return await response.text();
}

/**
 * 
 * @param {String} requestEndPointURL - Hodnota textového řetězce, která určuje konkrétní endpoint, který se má konktaktovat
 * @param {Array<{String : String}>} params - Paramtery pro GET request [{ "name" : value, "value", value }]
 * 
 * @throws {Error} vrátí chybu, když se nepovede získat odpověď
 * 
 * @returns {String} Hodnota textového řetězce obsahující očekávanou odpověď API
 */
export async function APIrequestGET(requestEndPointURL, params)
{
    let requestURL = api_base_url + requestEndPointURL + "?";
    Object.entries(params).forEach(
        ([key, value]) => 
            {
                requestURL += `${key}=${value}&`;
            }
        );
    const response = await fetch
    (
        requestURL,
        {
            method: 'GET',
            cache : 'no-store'
        }
    );

    if(!response.ok) 
    {
        const errorText = await response.text();
        console.error(`APIrequestGET Error: ${response.status} - ${errorText}`);

        throw new Error(`APIrequestGET Error: ${response.status} - ${errorText}`);
    }
    else 
        return await response.text();

}